<div class="tile__status" data-testid="tile"
    [ngClass]="{ 'tile__status--active': tile.params.workingStatus,
        'tile__status--inactive': !tile.params.workingStatus }">
    <div class="icon-wrapper">
        <svg-icon src="/assets/img/icons/fan.svg"
                  *ngIf="!tile.params.workingStatus">
        </svg-icon>
        <svg-icon src="/assets/img/icons/fan_active.svg"
                  *ngIf="tile.params.workingStatus"
                  [class]="'rotate'">
        </svg-icon>
    </div>
    <div class="tile__subtitle tile__subtitle--flex">
        <floating-subtitle
            *ngIf="tile.params.txtId && tile.params.txtId !== 'null' && tile.params.txtId !== '-1'"
            class="tile__subtitle-row ng-binding ng-scope-alert"
            [text]="subtitle(tile.params.txtId)">
        </floating-subtitle>
        <floating-subtitle
            *ngIf="tile.params.txtId === null || tile.params.txtId === 'null'
                || tile.params.txtId === '-1' || tile.params.txtId === -1"
            class="tile__subtitle-row ng-binding ng-scope"
            [text]="subtitle(459)">
        </floating-subtitle>
    </div>
    <div class="tile__value" data-testid="tile-value"
        *ngIf="tile.params.gear > 0">
        <circle-progress value="{{ tile.params.gear }}"
                         [showPath]="true"
                         [angleEnd]="3.6*tile.params.gear">
        </circle-progress>
    </div>
    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
           {{ subtitle(3162) }}
        </p>
    </div>
</div>
